import React from "react";
import { Loading, Spinner, LoadingText, Progress, ProgressFill } from "./styled";

// `progress` (0-100) is optional: screens that can measure their load pass it
// and get a thin bar under the label; the others keep the spinner alone.
const LoadingApp = ({ progress }) => {
  return (
    <Loading>
      <Spinner />
      <LoadingText>Carregando</LoadingText>
      {typeof progress === "number" ? (
        <Progress>
          <ProgressFill style={{ width: `${progress}%` }} />
        </Progress>
      ) : null}
    </Loading>
  );
};

export default LoadingApp;
